import { RouterProvider } from 'react-router-dom';

// routing
import router from 'routes';

// project imports
import NavigationScroll from 'layout/NavigationScroll';
import RTLLayout from 'ui-component/RTLLayout';
import Snackbar from 'ui-component/extended/Snackbar';
import Notistack from 'ui-component/third-party/Notistack';
import Locales from 'ui-component/Locales';

import ThemeCustomization from 'themes';

// auth provider imports
import { JWTProvider as AuthProvider } from 'contexts/JWTContext';
import { AdminAuthProvider } from 'contexts/AdminAuthContext';
import { SelectedMenuProvider } from 'contexts/SelectedMenuContext';

// ==============================|| APP ||============================== //

export default function App() {
  return (
    <>
      <Locales>
        <ThemeCustomization>
          <RTLLayout>
              <NavigationScroll>
                <AdminAuthProvider>
                  <SelectedMenuProvider>
                    <AuthProvider>
                      <>
                        <Notistack>
                          <RouterProvider router={router} />
                          <Snackbar />
                        </Notistack>
                      </>
                    </AuthProvider>
                  </SelectedMenuProvider>
                </AdminAuthProvider>
              </NavigationScroll>
          </RTLLayout>
        </ThemeCustomization>
      </Locales>
    </>
  );
}
